import { render, staticRenderFns } from "./treatment.vue?vue&type=template&id=48238cf8&"
import script from "./treatment.vue?vue&type=script&lang=js&"
export * from "./treatment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports